import Api from "../index";
import ApiConstants from "../ApiConstants";

let Base64 = require("js-base64").Base64;

export const getUserProfile = (data) => Api(ApiConstants.Auth.Me, null, data?.data?.Token);


export const changePassword = ({ data }) =>
  Api(ApiConstants.Auth.ChangePassword, { NewPassword: data.NewPassword });

export const loginUser = ({ data }) => {
  let UserPass = Base64.encode(`${data.Username}:${data.Password}`);
  return Api(
    ApiConstants.Auth.Login,
    {
      DeviceName: data.DeviceName,
      CaptchaCode: data.CaptchaCode,
      CaptchaText: data.CaptchaText,
    },
    null,
    "post",
    UserPass
  );
};

export const requestCaptcha = () => {
  return Api(ApiConstants.Auth.Captcha, null, null, "post");
};

export const sendCode = ({ data }) =>
  Api(ApiConstants.Auth.SendCode, {
    MobileNumber: data.MobileNumber,
    CaptchaCode: data.CaptchaCode,
    CaptchaText: data.CaptchaText,
  });

export const verifyCode = ({ data }) =>
  Api(ApiConstants.Auth.VerifyCode, {
    MobileNumber: data.MobileNumber,
    VerificationCode: data.VerificationCode,
    DeviceName: data.DeviceName,
  });

export const updateUserProfile = ({ data }) =>
  Api(ApiConstants.Auth.UpdateUserProfile, {
    FirstName: data.FirstName,
    LastName: data.LastName,
    ...(data.NationalIdentityNumber && {
      NationalIdentityNumber: data.NationalIdentityNumber,
    }),
    ...(data.PlaceOfIssue && { PlaceOfIssue: data.PlaceOfIssue }),
    ...(data.BirthCertificateNumber && {
      BirthCertificateNumber: data.BirthCertificateNumber,
    }),
    ...(data.Email && { Email: data.Email }),
    ...(data.BirthDate && { BirthDate: data.BirthDate }),
    ...(data.IssueDate && { IssueDate: data.IssueDate }),
  });

export const getUserTokens = () => Api(ApiConstants.Auth.Tokens, null);
